import {getInfo} from "./user_info"

let history = {live:[], movie:[], series:[]};
let favorite = {live:[], movie:[], series:[]};

export const initDb = () =>{
  try {
    const user = getInfo().username;
    let txt = localStorage.getItem("history-" + user);
    if(txt) history = JSON.parse(txt);
    
    txt = localStorage.getItem("favorite-" + user);
    if(txt) favorite = JSON.parse(txt);
  } catch(e) {
    console.error("Erro ao inicializar banco local", e);
  }
}

const findOne = (type, key, fav) =>{
  try {
    const db = fav === true ? favorite : history;
    if (!db[type]) return null;
    
    const el = db[type].find(x => parseInt(x.id) === parseInt(key));
    if(!el) return null;
    
    return fav !== true ? {...el, date: new Date(el.date)} : el;
  } catch(e) {
    return null;
  }
}

const findAll = (type, fav) =>{
  try {
    const db = fav === true ? favorite : history;
    if (!db[type]) return [];
    
    if(fav !== true)
        return db[type].sort((a,b) => b.date - a.date).map(x => ({...x, date : new Date(x.date)}));
    else return db[type];
  } catch(e) {
    return [];
  }
}

const set = (type,key,value, fav) =>{
  try {
    const db = fav === true ? favorite : history;
    if (!db[type]) db[type] = [];

    if (fav !== true) value = {...value, date: Date.now()};

    const i = db[type].findIndex(x => parseInt(x.id) === parseInt(key));
    if (i !== -1) db[type][i] = value;
    else db[type].unshift(value);

    reorderDB(fav);
    saveDB(fav);
  } catch(e) {
    console.error("Erro ao salvar no banco local", e);
  }
}

const del = (type, key, fav) =>{
  try {
    const db = fav === true ? favorite : history;
    if (!db[type]) return;
    
    db[type] = db[type].filter(x => parseInt(x.id) !== parseInt(key));
    saveDB(fav);
  } catch(e) {
    console.error("Erro ao deletar do banco local", e);
  }
}

const reorderDB = (fav) =>{
  if (fav !== true) {
    if(history.live) history.live = history.live.slice(0, 20).sort((a, b) => b.date - a.date)
    if(history.movie) history.movie = history.movie.slice(0, 20).sort((a, b) => b.date - a.date)
    if(history.series) history.series = history.series.slice(0, 20).sort((a, b) => b.date - a.date)
  }else{
    if(favorite.live) favorite.live = favorite.live.slice(0, 30)
    if(favorite.movie) favorite.movie = favorite.movie.slice(0, 30)
    if(favorite.series) favorite.series = favorite.series.slice(0, 30)
  }
}

const saveDB = (fav) =>{
  try {
    const user = getInfo().username;
    window.localStorage.setItem((fav !== true ? "history-" : "favorite-") + user, JSON.stringify(fav !== true ? history : favorite));
  } catch(e) {}
}

export default {findOne, findAll, set, del}
